import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import ProfileWrapper from "components/profile/ProfileWrapper";
import { UserStatsPageProps } from "./index.props";
import StatsPage from "components/stats/v2/StatsPage";
import Callout from "hardcover-ui/components/Callout";
import Heading from "hardcover-ui/components/Heading";

function UserStatsPage() {
  const { user } = usePage<UserStatsPageProps>().props;

  return (
    <ProfileWrapper user={user}>
      <Callout className="relative my-4 space-y-1 mx-4">
        <Heading level={2} variant="title" size="sm" className="mb-2">
          You're Viewing a Preview
        </Heading>
        <p>
          We still have a bunch of work to do on these to match Ste's vision,
          but we wanted you to see a preview while in the meantime!
        </p>
        <p>
          If you run into any errors, we'll be automatically notified. However,
          if you notice any charts that seem off, please email a link to the
          page and how it's off <b>jules@hardcover.app</b>. That'll help us fix
          it faster!
        </p>
      </Callout>
      <StatsPage />
    </ProfileWrapper>
  );
}

UserStatsPage.layout = DefaultLayoutWrapper;
export default UserStatsPage;
